import { render, staticRenderFns } from "./AreasFormDialogShell.vue?vue&type=template&id=701970de&scoped=true"
import script from "./AreasFormDialogShell.vue?vue&type=script&lang=js"
export * from "./AreasFormDialogShell.vue?vue&type=script&lang=js"
import style0 from "./AreasFormDialogShell.vue?vue&type=style&index=0&id=701970de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701970de",
  null
  
)

export default component.exports